import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  // load translations using http (default public/locales folder)
  .use(Backend)
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    fallbackLng: 'en',
    // Only support these specific languages
    supportedLngs: ['en', 'fr'],
    // Normalize language detection to only 'en' or 'fr'
    load: 'languageOnly',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    // backend configuration
    backend: {
      // path where resources get loaded from
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    // define namespaces for logical separation of translations
    ns: ['common', 'calendar', 'auth', 'flypro', 'customers', 'notifications'],
    defaultNS: 'common',
    // Disable suspense mode to prevent the error
    react: {
      useSuspense: false
    }
  });

export default i18n;
